import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import LoginForm from "@Components/LoginForm";
import { useAuth } from "../contexts/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import { MULTI, VerticeLogo } from "@Components/VerticeLogo";
const LoginPage = () => {
    const { isAuthenticated } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const next = queryParams.get('next');
    console.log("(LoginPage) isAuthenticated: ", isAuthenticated);
    useEffect(() => {
        const nextRoute = next ? next : '/';
        if (isAuthenticated) {
            navigate(nextRoute);
        }
    }, [isAuthenticated]);
    return (_jsx(_Fragment, { children: _jsxs(Box, { sx: {
                display: "flex",
                flexDirection: "column",
                alignContent: "center",
                alignItems: "center",
                justifyContent: "start",
                paddingTop: '50px',
                width: '100%',
                height: '100%',
                backgroundColor: "#838383",
            }, children: [_jsx(VerticeLogo, { color: MULTI, width: "913px", height: "250px" }), _jsx(Typography, { variant: "h4", align: "center", sx: { marginTop: '2rem' }, gutterBottom: true, children: "Login" }), _jsx(LoginForm, {})] }) }));
};
export default LoginPage;
